import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastViewport } from '@nako/ui';
import { useAuthStore } from '@/stores/auth';
import { AppShell } from '@/components/AppShell';
import { RequireAuth } from '@/components/RequireAuth';

import Welcome from '@/pages/Welcome';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';
import Admin from '@/pages/Admin';
import Dashboard from '@/pages/Dashboard';
import Receipts from '@/pages/Receipts';
import ReceiptScan from '@/pages/ReceiptScan';
import Reports from '@/pages/Reports';
import Invoices from '@/pages/Invoices';
import Inventory from '@/pages/Inventory';
import FixedAssets from '@/pages/FixedAssets';
import Customers from '@/pages/Customers';
import Suppliers from '@/pages/Suppliers';
import Journal from '@/pages/Journal';
import Payroll from '@/pages/Payroll';
import Cashbook from '@/pages/Cashbook';
import Reminders from '@/pages/Reminders';
import BURS from '@/pages/BURS';
import Settings from '@/pages/Settings';
import Patients from '@/pages/Patients';
import Pharmacy from '@/pages/Pharmacy';

export default function App() {
  const init = useAuthStore((s) => s.init);
  useEffect(() => {
    void init();
  }, [init]);

  return (
    <ToastViewport>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/signup"
          element={
            <RequireAuth needsBusiness={false}>
              <Signup />
            </RequireAuth>
          }
        />

        <Route
          path="/admin"
          element={
            <RequireAuth needsBusiness={false} needsAdmin>
              <Admin />
            </RequireAuth>
          }
        />

        <Route
          path="/app"
          element={
            <RequireAuth>
              <AppShell>
                <Dashboard />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/receipts"
          element={
            <RequireAuth>
              <AppShell>
                <Receipts />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/receipts/scan"
          element={
            <RequireAuth>
              <AppShell>
                <ReceiptScan />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/reports"
          element={
            <RequireAuth>
              <AppShell>
                <Reports />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/invoices"
          element={
            <RequireAuth>
              <AppShell>
                <Invoices />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/inventory"
          element={
            <RequireAuth>
              <AppShell>
                <Inventory />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/assets"
          element={
            <RequireAuth>
              <AppShell>
                <FixedAssets />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/customers"
          element={
            <RequireAuth>
              <AppShell>
                <Customers />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/suppliers"
          element={
            <RequireAuth>
              <AppShell>
                <Suppliers />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/journal"
          element={
            <RequireAuth>
              <AppShell>
                <Journal />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/payroll"
          element={
            <RequireAuth>
              <AppShell>
                <Payroll />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/cashbook"
          element={
            <RequireAuth>
              <AppShell>
                <Cashbook />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/reminders"
          element={
            <RequireAuth>
              <AppShell>
                <Reminders />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/burs"
          element={
            <RequireAuth>
              <AppShell>
                <BURS />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/settings"
          element={
            <RequireAuth>
              <AppShell>
                <Settings />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/patients"
          element={
            <RequireAuth>
              <AppShell>
                <Patients />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/app/pharmacy"
          element={
            <RequireAuth>
              <AppShell>
                <Pharmacy />
              </AppShell>
            </RequireAuth>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastViewport>
  );
}
